import { IInternalTransferData } from '../../IInternalTransferData';
import { eInternalTransferCategory } from '../../../../accounting/response/eInternalTransferCategory';

export interface IInternalTransferPatchData {
  id: string;
  amountCents?: number;
  category?: eInternalTransferCategory;
  destinationAccountId: string;
}

export const convertIInternalTransferDataToIInternalTransferPatchData = ({
  id,
  amountCents,
  category,
  destinationAccount,
}: IInternalTransferData): IInternalTransferPatchData => ({
  id,
  amountCents,
  category,
  destinationAccountId: destinationAccount.id,
});
